import { validateEmail } from '@/libs/utils';
import { ValidationRule } from '../hooks/useFormValidation';

/**
 * Validateurs réutilisables pour les formulaires d'authentification
 */

export const emailValidator: ValidationRule<string> = {
  validate: (email: string): string | null => {
    if (!email.trim()) {
      return 'Veuillez entrer une adresse valide';
    }
    if (!validateEmail(email)) {
      return 'Veuillez entrer une adresse valide';
    }
    return null;
  },
};

export const requiredValidator = (fieldName: string): ValidationRule<string> => ({
  validate: (value: string): string | null => {
    if (!value.trim()) {
      return `${fieldName} est requis`;
    }
    return null;
  },
});

export const passwordValidator: ValidationRule<string> = {
  validate: (password: string): string | null => {
    if (password.length < 8) {
      return 'Le mot de passe doit contenir au moins 8 caractères';
    }
    if (!/[A-Z]/.test(password)) {
      return 'Le mot de passe doit contenir au moins une majuscule';
    }
    if (!/[0-9]/.test(password)) {
      return 'Le mot de passe doit contenir au moins un chiffre';
    }
    if (!/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password)) {
      return 'Le mot de passe doit contenir au moins un caractère spécial';
    }
    return null;
  },
};
